import React from 'react';
import { View, TouchableOpacity, StyleSheet } from 'react-native';
import { Text } from '@/components/common/text';
import { PRIMITIVE_COLORS } from '@/constants/residents/residentColors';
import { useThemeColors } from '@/hooks/residents/useThemeColors';
import { REDESIGN_TYPOGRAPHY } from '@/constants/residents/homeConstants';
import { RESIDENTS_SVG_COMPONENTS } from '@/assets/residents';
import { GlassCard } from '../GlassCard';

interface UploadCTAProps {
  onPress: () => void;
}

export const UploadCTA: React.FC<UploadCTAProps> = React.memo(({ onPress }) => {
  const { colors } = useThemeColors();

  return (
    <TouchableOpacity activeOpacity={0.7} onPress={onPress}>
      <GlassCard dashed borderRadius={12} padding={0} style={styles.card}>
        <View style={[styles.iconContainer, { backgroundColor: colors.accent.blueBgMedium }]}>
          <RESIDENTS_SVG_COMPONENTS.PROPERTY
            width={16}
            height={16}
            color={PRIMITIVE_COLORS.resioBlue}
          />
        </View>
        <Text style={[styles.text, { color: colors.text.dimmer }]}>
          <Text style={{ color: PRIMITIVE_COLORS.resioBlue }}>Upload</Text>
          {' a background photo'}
        </Text>
      </GlassCard>
    </TouchableOpacity>
  );
});

UploadCTA.displayName = 'UploadCTA';

const styles = StyleSheet.create({
  card: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 10,
    paddingHorizontal: 19,
    paddingVertical: 15,
    marginBottom: 16,
  },
  iconContainer: {
    width: 32,
    height: 32,
    borderRadius: 8,
    alignItems: 'center',
    justifyContent: 'center',
  },
  text: {
    ...REDESIGN_TYPOGRAPHY.small,
  },
});
